import { render } from "./plus.svg?vue&type=template&id=a0c31974"
const script = {}

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__